import React from 'react';
import { motion } from 'framer-motion';
import { Check, Target, X } from 'lucide-react';
const notThis = ['This is not a random collection of boxing drills.', 'This is not a theoretical boxing book that still leaves you responsible for building the actual sessions.', 'This is not a generic fitness program disguised as boxing coaching.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-cream relative overflow-hidden" data-id="element-228" data-mp="z0uw6yruec05">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gold/60" data-id="element-229" data-mp="z37kdto71iln" />
      <div className="max-w-4xl mx-auto text-center" data-id="element-230" data-mp="u4mlbxkoh4ys">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-231" data-mp="182udztaolk45">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-ink text-white mb-5" data-id="element-232" data-mp="2jfeq54fysp5b">
            <Target size={26} aria-hidden="true" data-id="element-233" data-mp="2fhz3ffzg9dia" />
          </div>
          <h2 className="text-2xl md:text-4xl font-display font-extrabold mb-4 text-ink" data-id="element-234" data-mp="2buxjxjbdt3f5">
            The complete ready-to-coach boxing system for coaches worldwide
          </h2>
          <h3 className="text-xl font-bold text-accent mb-3" data-id="element-235" data-mp="2kxgi3q482rv2">Boxing Coach Ready</h3>
          <p className="text-base md:text-lg text-graphite mb-10" data-id="element-236" data-mp="2pw03npewm1mw">
            7 complete volumes · 150 ready-to-coach sessions · 5 bonus guides · Ready to use today
          </p>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-237" data-mp="1x6b3tfdxk7mv">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-paper p-6 rounded-2xl border border-silver-light" data-id="element-238" data-mp="1x4ggjuf6s3fm">
            {notThis.map(item => <div key={item} className="flex items-start gap-3" data-id="element-239" data-mp="1ef0ev3rrm4xm">
                <X className="text-silver shrink-0 mt-1" size={18} aria-hidden="true" data-id="element-240" data-mp="2hqz0142uyn9i" />
                <p className="text-graphite-light text-sm" data-id="element-241" data-mp="2cs5npezb52ax">{item}</p>
              </div>)}
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-ink p-6 rounded-2xl border border-ink" data-id="element-242" data-mp="2qjskdfx5wcu8">
            <div className="flex items-start gap-3" data-id="element-243" data-mp="1tu1r1k0lwvq0">
              <Check className="text-accent shrink-0 mt-1" size={20} aria-hidden="true" data-id="element-244" data-mp="1tvcx5qhiyfka" />
              <div data-id="element-245" data-mp="27uckmutawoev">
                <p className="text-white font-display font-bold text-lg mb-2" data-id="element-246" data-mp="27qorvxvok617">
                  This is a complete professional coaching system.
                </p>
                <p className="text-white/80 text-base leading-relaxed" data-id="element-247" data-mp="3j6n42am5n86n">
                  A system designed to help you walk into the gym prepared, structured and clear
                  about exactly what you want your athletes to develop.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}